import { render, staticRenderFns } from "./carShow.vue?vue&type=template&id=715ac236&scoped=true&"
import script from "./carShow.vue?vue&type=script&lang=js&"
export * from "./carShow.vue?vue&type=script&lang=js&"
import style0 from "./carShow.vue?vue&type=style&index=0&id=715ac236&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ac236",
  null
  
)

export default component.exports